<template>
  <van-sku
    v-model="show"
    :sku="sku"
    :goods="goods"
    :goods-id="goodsId"
    :show-add-cart-btn="false"
    buy-text="确定"
    @buy-clicked="addOne"
  />
</template>

<script>
  export default {
    name: 'Ceshi',
    data() {
      return {
        show: true,
        sku: {
          price: '1.00',
          stock_num: 227,
          none_sku: false,
          hide_stock: false,
          collection_id: 2261,
          tree: [
            {
              k: '颜色',
              k_id: '1',
              v: [
                {
                  id: '30349',
                  name: '天蓝色',
                  imgUrl:
                    'https://img.yzcdn.cn/upload_files/2017/02/21/FjKTOxjVgnUuPmHJRdunvYky9OHP.jpg!100x100.jpg',
                },
                {
                  id: '1215',
                  name: '白色',
                  imgUrl:
                    'https://img.yzcdn.cn/upload_files/2017/03/16/Fs_OMbSFPa183sBwvG_94llUYiLa.jpeg?imageView2/2/w/100/h/100/q/75/format/jpg',
                }
              ],
              k_s: 's1',
              count: 2
            },
            {
              k: '尺寸',
              k_id: '2',
              v: [
                {
                  id: '1193',
                  name: '1'
                },
                {
                  id: '1194',
                  name: '2'
                }
              ],
              k_s: 's2',
              count: 2
            }
          ],
          list: [
            {
              id: 2259,
              price: 100,
              discount: 100,
              code: '',
              s1: '1215',
              s2: '1193',
              s3: '0',
              s4: '0',
              s5: '0',
              stock_num: 110,
              goods_id: 946755
            },
            {
              id: 2260,
              price: 100,
              discount: 100,
              code: '',
              s1: '1215',
              s2: '1194',
              s3: '0',
              s4: '0',
              s5: '0',
              stock_num: 0,
              goods_id: 946755
            },
            {
              id: 2257,
              price: 100,
              discount: 100,
              code: '',
              s1: '30349',
              s2: '1193',
              s3: '0',
              s4: '0',
              s5: '0',
              stock_num: 111,
              goods_id: 946755
            },
            {
              id: 2258,
              price: 100,
              discount: 100,
              code: '',
              s1: '30349',
              s2: '1194',
              s3: '0',
              s4: '0',
              s5: '0',
              stock_num: 6,
              goods_id: 946755
            }
          ],
        },
        goodsId: 1000,
        goods: {
          //商品标题
          title: '测试商品',
          //默认商品缩略图
          picture: 'https://img.yzcdn.cn/upload_files/2017/03/16/Fs_OMbSFPa183sBwvG_94llUYiLa.jpeg?imageView2/2/w/100/h/100/q/75/format/jpg'
        }
      }
    },
    methods:{
      addOne(){
        console.log("买")
      }
    }
  };
</script>

<style scoped>

</style>
